<template>
  <page-layout :title="title">
    <template v-slot:breadcrumb>
      <li><router-link :to="{ name: 'home' }">Dashboard</router-link></li>
      <li><router-link :to="{ name: 'tutorial.list' }">Tutoriels</router-link></li>
      <li class="is-active">
        <a href="#">{{ title }}</a>
      </li>
    </template>
    <div class="box">
      <add-live-tutorial />
    </div>
  </page-layout>
</template>

<script>
import PageLayout from '@components/PageLayout.vue'
import AddLiveTutorial from '@views/LiveTutorial/AddLiveTutorial.vue'

export default {
  name: 'AddLiveTutorialPage',

  components: {
    PageLayout,
    AddLiveTutorial,
  },

  data() {
    return {
      title: 'Ajouter un tutoriel',
    }
  },
}
</script>
